<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Warning Message -->
@if (isExcludedWarning || isincludedWarning) {
<div class="warning-msg-class">
  <div id="inner"><strong>{{ isExcludedWarningMsgs }}</strong></div>
  <div><br></div>
</div>
}

<!-- STANDARD Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise">
  @if (crudLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!crudLoading) {
<div>
    <div class="col-md-12">
      <div class="table-scroll" style="padding-top: 0 !important;">
        <table class="main-table custom-table">
          <thead>
            <tr>
              <th class="sticky-col"></th>
              <th class="sticky-col">Warning</th>
              <th class="sticky-col">LEID</th>
              <th class="sticky-col">Tax Code</th>
              <th class="sticky-col">Reporting Period</th>
              <th class="sticky-col">ME Code</th>
              <th class="sticky-col">Local Acct</th>
              <th class="sticky-col">System Acct</th>
              <th class="sticky-col">PY Amt</th>
              <th class="sticky-col">CY Amt</th>
            </tr>
          </thead>
          <tbody>
            @for (t of getSortedData(); track $index) {
<tr>
              <td>
                <i class="fa fa-times" 
                   title="Remove Row"
                   style="cursor: pointer;"
                   (click)="removeRow(t)"></i>
              </td>
              <td [ngClass]="{'warning-class': t.INC_EXC_STATUS_FLAG === 1, 'default-color': t.INC_EXC_STATUS_FLAG === 0}">
                @if (t.INC_EXC_STATUS_FLAG === 1) {
<span>{{t.INC_EXC_STATUS}}</span>
}
              </td>
              <td>{{ t.LEID }}</td>
              <td>{{ t.CDR_NO }}</td>
              <td>{{ t.REPORTING_PERIOD }}</td>
              <td>{{ t.ME_CODE }}</td>
              <td>{{ t.LOCAL_ACCT }}</td>
              <td>{{ t.SYSTEM_ACCT }}</td>
              <td>{{ t.PY_AMT }}</td>
              <td>{{ t.CY_AMT }}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked || isExcludedWarning || savingFlag || isincludedWarning" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
